// src/components/401kCalculator.jsx
import React, { useState } from 'react';
import './ZakahCalculator.css';

const Retirement401kCalculator = () => {
  const [formData, setFormData] = useState({
    withdrawalAmount: 100000, // Default value as seen in the screenshot
    currentAge: 60, // Default age for the calculations
    federalTaxRate: 24, // Default federal tax rate
    stateTaxRate: 0, // Default state tax rate
  });

  const [results, setResults] = useState({
    penalties: 0,
    taxes: 0,
    netWithdrawal: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const calculate401k = () => {
    const { withdrawalAmount, currentAge, federalTaxRate, stateTaxRate } = formData;

    // Calculate penalties
    const penalties = currentAge < 59.5 ? withdrawalAmount * 0.10 : 0;

    // Calculate taxes
    const taxes = withdrawalAmount * (federalTaxRate / 100 + stateTaxRate / 100);

    // Calculate net withdrawal
    const netWithdrawal = withdrawalAmount - penalties - taxes;

    setResults({
      penalties: penalties.toFixed(2),
      taxes: taxes.toFixed(2),
      netWithdrawal: netWithdrawal.toFixed(2),
    });
  };

  return (
    <div>
      <h2>401k Early Withdrawal Calculator</h2>
      <h3>Speak with a tax specialist for any exemptions or special circumstances</h3>
      <div>
        <label>Amount to withdraw: </label>
        <input
          type="number"
          name="withdrawalAmount"
          value={formData.withdrawalAmount}
          onChange={handleChange}
          className="input-field"
        />
      </div>
      <div>
        <label>Current age: </label>
        <input
          type="number"
          name="currentAge"
          value={formData.currentAge}
          onChange={handleChange}
          className="input-field"
        />
      </div>
      <div>
        <label>Federal income tax rate (%): </label>
        <input
          type="number"
          name="federalTaxRate"
          value={formData.federalTaxRate}
          onChange={handleChange}
          className="input-field"
        />
      </div>
      <div>
        <label>State income tax rate (%): </label>
        <input
          type="number"
          name="stateTaxRate"
          value={formData.stateTaxRate}
          onChange={handleChange}
          className="input-field"
        />
      </div>
      <button onClick={calculate401k}
      style={{
        margin: '10px',
        padding: '15px 25px',
        borderRadius: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: '#333',
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'scale(1.05)';
        e.target.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
        e.target.style.backgroundColor = '#f0e68c';
        e.target.style.color = '#0c1a2b';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = 'none';
        e.target.style.backgroundColor = '#333';
        e.target.style.color = 'white';
      }}
      onMouseDown={(e) => {
        e.target.style.transform = 'scale(0.98)';
        e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
      }}
      onMouseUp={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = 'none';
      }}>
        Calculate </button>

      {results.netWithdrawal !== 0 && (
        <div>
          <h3>Results</h3>
          <p>Penalties: ${results.penalties}</p>
          <p>Taxes: ${results.taxes}</p>
          <p>Net Withdrawal: ${results.netWithdrawal}</p>
        </div>
      )}
    </div>
  );
};

export default Retirement401kCalculator;
